var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.384 17.941"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.702.708l8.263 8.263-8.263 8.263",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "9d0a77d2634f2e19eaf47df4ef9cdfc8.svg";
export { SvgChevronRight as ReactComponent };